import { useState, useEffect } from "react";
import { C, NAV_ITEMS } from "../data/constants";
import { scrollTo } from "../hooks/useScrollFade";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close menu on resize to desktop
  useEffect(() => {
    const onResize = () => { if (window.innerWidth > 860) setMenuOpen(false); };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const handleNav = (item) => {
    scrollTo(item.toLowerCase().replace(/ /g, "-"));
    setMenuOpen(false);
  };

  return (
    <>
      <style>{`
        .nav-wrap {
          position: fixed; top: 0; left: 0; right: 0; z-index: 100;
          background: ${scrolled ? "rgba(236,228,215,0.98)" : "rgba(236,228,215,0.95)"};
          backdrop-filter: blur(12px);
          border-bottom: 1px solid ${C.linen};
          transition: box-shadow 0.3s;
          box-shadow: ${scrolled ? "0 2px 16px rgba(44,40,38,0.08)" : "none"};
        }
        .nav-inner {
          max-width: 1200px; margin: 0 auto;
          padding: 0 24px;
          display: flex; align-items: center; justify-content: space-between;
          height: 62px;
        }
        .nav-logo { background: none; border: none; cursor: pointer; text-align: left; flex-shrink: 0; }
        .nav-logo h2 { font-size: clamp(15px, 2vw, 19px); color: ${C.dark}; font-weight: 600; line-height: 1.1; white-space: nowrap; }
        .nav-logo p  { font-size: 9px; color: ${C.slate}; letter-spacing: 2.5px; text-transform: uppercase; }

        .nav-links { display: flex; align-items: center; gap: 16px; }
        .nav-link  { background: none; border: none; cursor: pointer; font-size: 12px; color: ${C.mid}; font-family: 'Jost',sans-serif; white-space: nowrap; padding: 4px 0; transition: color 0.2s; }
        .nav-link:hover { color: ${C.blush}; }
        .nav-cta   { background: ${C.blush}; color: #FAFAF8 !important; padding: 8px 18px; border-radius: 20px; font-size: 12px; text-decoration: none; font-weight: 500; white-space: nowrap; transition: opacity 0.2s; }
        .nav-cta:hover { opacity: 0.88; }

        .nav-burger { display: none; flex-direction: column; gap: 5px; background: none; border: none; cursor: pointer; padding: 6px; }
        .nav-burger span { display: block; width: 22px; height: 2px; background: ${C.dark}; border-radius: 2px; transition: all 0.3s; }

        .nav-mobile {
          display: none; position: fixed; top: 62px; left: 0; right: 0; z-index: 99;
          background: rgba(236,228,215,0.99); backdrop-filter: blur(14px);
          border-bottom: 1px solid ${C.linen};
          flex-direction: column; padding: 12px 24px 20px;
          box-shadow: 0 8px 24px rgba(44,40,38,0.1);
          max-height: calc(100vh - 62px); overflow-y: auto;
        }
        .nav-mobile.open { display: flex !important; }
        .nav-mobile-link {
          background: none; border: none; cursor: pointer;
          font-size: 16px; color: ${C.mid}; font-family: 'Jost',sans-serif;
          text-align: left; padding: 13px 0;
          border-bottom: 1px solid ${C.linen};
          transition: color 0.2s;
        }
        .nav-mobile-link:hover { color: ${C.blush}; }
        .nav-mobile-cta {
          display: block; background: ${C.blush}; color: #FAFAF8;
          padding: 13px 20px; border-radius: 24px; font-size: 15px;
          text-decoration: none; font-weight: 500; text-align: center; margin-top: 14px;
        }

        @media (max-width: 860px) {
          .nav-links  { display: none !important; }
          .nav-burger { display: flex !important; }
        }
      `}</style>

      <nav className="nav-wrap">
        <div className="nav-inner">
          <button className="nav-logo" onClick={() => handleNav("home")}>
            <h2>Moments & Milestones</h2>
            <p>Event Company · Cape Town</p>
          </button>

          {/* Desktop */}
          <div className="nav-links">
            {NAV_ITEMS.map(n => (
              <button key={n} className="nav-link" onClick={() => handleNav(n)}>{n}</button>
            ))}
            <a href="https://wa.me/27686753020" target="_blank" rel="noreferrer" className="nav-link nav-cta">
              WhatsApp Us
            </a>
          </div>

          {/* Hamburger */}
          <button className="nav-burger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
            <span style={{ transform: menuOpen ? "rotate(45deg) translate(5px,5px)" : "none", background: menuOpen ? C.blush : C.dark }} />
            <span style={{ opacity: menuOpen ? 0 : 1 }} />
            <span style={{ transform: menuOpen ? "rotate(-45deg) translate(5px,-5px)" : "none", background: menuOpen ? C.blush : C.dark }} />
          </button>
        </div>
      </nav>

      {/* Mobile dropdown */}
      <div className={`nav-mobile ${menuOpen ? "open" : ""}`}>
        {NAV_ITEMS.map(n => (
          <button key={n} className="nav-mobile-link" onClick={() => handleNav(n)}>{n}</button>
        ))}
        <a href="https://wa.me/27686753020" target="_blank" rel="noreferrer" className="nav-mobile-cta">
          WhatsApp Us
        </a>
      </div>
    </>
  );
}